<template>
  <div id="Services">
    <img :src="this.serviceUrl" alt="" />
  </div>
</template>

<script>
import { getServiceList } from "../axiosAPI";

export default {
  name: "Services",
  data() {
    return {
      serviceUrl: "",
    };
  },
  created() {
    let query = this.$qs.stringify({
      type: this.$route.query.type,
    });
    getServiceList(query).then((res) => {
      if (res.data.code == 200) {
        this.serviceUrl = res.data.item.servicePictureUrl;
        console.log(this.serviceUrl, "res.this.serviceUrl");
      }
    });
  },
};
</script>

<style lang="less" scoped>
#Services {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  img {
    width: 100%;
  }
}
</style>
